export default __webpack_public_path__ + "static/media/sf5.1fa9c2eb.jpeg";